import { gql } from '@apollo/client';

/* Earnings & payouts ------------------------------------------------------- */

// NOTE: the payout fields are inlined (not extracted into a fragment) because
// the three payout lists do not share a single named GraphQL type we can pin a
// fragment to. This mirrors the original working query.
export const GET_VENDOR_EARNINGS = gql`
  query GetVendorEarnings($vendorId: String!, $month: MonthEnum!, $year: Int!, $inStore: Boolean) {
    getVendorEarnings(vendorId: $vendorId, month: $month, year: $year, inStore: $inStore) {
      month
      year
      instoreSalesTotal
      paidAmount
      totalAmount
      upcomingAmount
      paidPayouts {
        id
        orderId
        orderNumber
        orderAmount
        deliveryFee
        handlingFee
        platformFee
        totalTax
        vendorPayoutAmount
        expectedPayoutAt
        items {
          itemName
          itemImageUrl
          quantity
          status
          deliveredAt
          processedAt
          expectedPayoutAt
          cess
          cgst
          sgst
          igst
          platformFee
          payoutAmount
          totalEarnings
          totalTax
        }
      }
      totalPayouts {
        id
        orderId
        orderNumber
        orderAmount
        deliveryFee
        handlingFee
        platformFee
        totalTax
        vendorPayoutAmount
        expectedPayoutAt
        items {
          itemName
          itemImageUrl
          quantity
          status
          deliveredAt
          processedAt
          expectedPayoutAt
          cess
          cgst
          sgst
          igst
          platformFee
          payoutAmount
          totalEarnings
          totalTax
        }
      }
      upcomingPayouts {
        id
        orderId
        orderNumber
        orderAmount
        deliveryFee
        handlingFee
        platformFee
        totalTax
        vendorPayoutAmount
        expectedPayoutAt
        items {
          itemName
          itemImageUrl
          quantity
          status
          deliveredAt
          processedAt
          expectedPayoutAt
          cess
          cgst
          sgst
          igst
          platformFee
          payoutAmount
          totalEarnings
          totalTax
        }
      }
    }
  }
`;

export const GET_MONTHS_ENUMS = gql`
  query GetMonthsEnums($languageCode: String) {
    getMonthsEnums(languageCode: $languageCode) {
      displayValue
      name
      value
    }
  }
`;

export const GET_PAYOUT_STATUS = gql`
  query GetPayoutStatus($languageCode: String) {
    getPayoutStatus(languageCode: $languageCode) {
      displayValue
      enumName
      isSupported
      value
    }
  }
`;

/* Bank accounts / Razorpay linked accounts --------------------------------- */

export const GET_BANK_ACCOUNTS = gql`
  query GetBankAccounts {
    getBankAccounts {
      id
      accountNumber
      beneficiaryName
      ifscCode
      kycStatus
      status
      razorpayAccountId
      vendorId
      isPrimaryAccount
      email
    }
  }
`;

export const CREATE_LINKED_ACCOUNTS = gql`
  mutation CreateLinkedAccounts($vendorId: String!, $input: VendorBankAccountInput!) {
    createLinkedAccounts(vendorId: $vendorId, input: $input) {
      error
      message
    }
  }
`;

export const UPDATE_BANK_DETAILS = gql`
  mutation UpdateBankDetails($accountId: String!, $input: VendorBankAccountInput!) {
    updateBankDetails(accountId: $accountId, input: $input) {
      error
      message
    }
  }
`;

export const VERIFY_LINKED_ACCOUNT = gql`
  mutation VerifyLinkedAccount($razorpayaccountId: String!) {
    verifyLinkedAccount(razorpayaccountId: $razorpayaccountId) {
      error
      linkedAccountStatus
    }
  }
`;

export const SET_IS_PRIMARY_ACCOUNT = gql`
  mutation SetIsPrimaryAccount($accountId: String!) {
    setIsPrimaryAccount(accountId: $accountId) {
      message
    }
  }
`;

export const VERIFY_RAZORPAY_SIGNATURE = gql`
  mutation VerifyRazorpaySignature($input: RazorpaySignatureDetails!) {
    verifyRazorpaySignature(input: $input) {
      message
    }
  }
`;
